import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function SparkleLanding() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container product-landing sparkle-landing">
          <div className="section-header">
            <span className="section-badge">Sparkle</span>
            <h1 className="product-title sparkle-title landing-product-title">
              <span>
                <span className="sparkle-title-text">Sparkle</span>
                <span className="sparkle-title-copyright">©</span>
              </span>
            </h1>
            <p className="section-description landing-description">
              {translate("sparkleDescLong", language)}
            </p>
          </div>
          <div className="landing-cta">
            <a
              href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
                translate("sparkleTitle", language) +
                  " - " +
                  (language === "fr" ? "Contact" : "Contact")
              )}`}
              className="landing-link"
            >
              {translate("contactSupport", language)}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default SparkleLanding;
